import React, {FC} from 'react';

import {connect} from 'react-redux';

import {useFeature} from 'components/feature';
import {LoadingOverlay} from 'components/loadingOverlay/loadingOverlay';
import {ApplicationStoreType} from 'desktop/store';

import {STEPS} from '../../constants/checkout';
import {PAYMENTS} from '../../constants/paymentStep';
import {useGetIsUserWithAddress} from '../../hooks/useGetIsUserWithAddress/useGetIsUserWithAddress';
import {getCurrentStep} from '../../store/selectors/currentStep/currentStep';
import {isDeliveryStepLoaded} from '../../store/selectors/deliveryStep/deliveryStep';
import {getNameSelectedMethod} from '../../store/selectors/paymentStep/paymentStep';
import {DeliveryFormWrapperConnected} from '../deliveryFormWrapper/deliveryFormWrapper';
import {StepResumeConnected} from '../deliveryStepResume/deliveryStepResume';
import {StepResumeAmazonConnected} from '../deliveryStepResumeAmazon/deliveryStepResumeAmazon';
import {StepBody} from '../stepBody/stepBody';
import {StepTitle} from '../stepTitle/stepTitle';
import {StepWrapper} from '../stepWrapper/stepWrapper';

export type PropsType = {
    currentStep: STEPS;
    isStepLoaded: boolean;
    paymentMethod: PAYMENTS;
};

/**
 * Delivery Step for checkout
 *
 * @constructor
 */
export const DeliveryStep: FC<PropsType> = ({currentStep, isStepLoaded, paymentMethod}) => {
    const isFacelift = useFeature('dCheckoutFacelift');

    const isUserWithAddress = useGetIsUserWithAddress();

    return (
        <StepWrapper step={STEPS.DELIVERY_STEP}>
            <StepTitle
                resumeComponent={
                    paymentMethod === PAYMENTS.METHOD_AMAZON_V2 ? (
                        <StepResumeAmazonConnected />
                    ) : (
                        <StepResumeConnected />
                    )
                }
                currentStep={currentStep}
                step={STEPS.DELIVERY_STEP}
            >
                {isFacelift ? 'Shipping' : 'Delivery'}
            </StepTitle>
            <StepBody currentStep={currentStep} step={STEPS.DELIVERY_STEP}>
                {!isStepLoaded && <LoadingOverlay aria-label="Loading delivery step" />}
                <DeliveryFormWrapperConnected isUserWithAddress={isUserWithAddress} />
            </StepBody>
        </StepWrapper>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    currentStep: getCurrentStep(store),
    isStepLoaded: isDeliveryStepLoaded(store),
    paymentMethod: getNameSelectedMethod(store),
});

export const DeliveryStepConnected = connect(mapStateToProps)(DeliveryStep);
